// src/pages/AboutPage.jsx
import React from "react";
import { useInView } from "react-intersection-observer";
import aboutHero from "../assets/images/aboutHero.png";
import Hero from "../components/hero/Hero";
import Phone from "../assets/images/phone.png";
import visi from "../assets/images/visi.png";
import misi from "../assets/images/misi.png";
import collaboration from "../assets/images/collaboration.png";
import openness from "../assets/images/openness.png";
import novelty from "../assets/images/novelty.png";
import nurturance from "../assets/images/nuturance.png";
import equity from "../assets/images/equity.png";
import customerCentric from "../assets/images/customer-centric.png";
import trustworthiness from "../assets/images/trustworthiness.png";
import Footer from "../components/footer/Footer";

const AboutPage = () => {
  // Gunakan useInView untuk gambar Phone
  const { ref: phoneRef, inView: phoneInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  // Gunakan useInView untuk Visi & Misi
  const { ref: vmRef, inView: vmInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  // Gunakan useInView untuk Nilai Kami
  const { ref: valuesRef, inView: valuesInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  // Data Nilai Kami: CONNECT
  const values = [
    {
      image: collaboration,
      title: "Collaboration",
      subtitle: "Kolaborasi yang berkelanjutan",
    },
    {
      image: openness,
      title: "Openness",
      subtitle: "Transparan dan komunikasi terbuka",
    },
    {
      image: novelty,
      title: "Novelty",
      subtitle: "Inovasi sebagai budaya",
    },
    {
      image: nurturance,
      title: "Nurturance",
      subtitle: "Pengembangan SDM dan mitra",
    },
    {
      image: equity,
      title: "Equity",
      subtitle: "Kesetaraan dan keadilan dalam layanan",
    },
    {
      image: customerCentric,
      title: "Customer-Centric",
      subtitle: "Pelanggan adalah pusat dari semua keputusan",
    },
    {
      image: trustworthiness,
      title: "Trustworthiness",
      subtitle: "Kepercayaan adalah mata uang utama kami",
    },
  ];

  return (
    <>
      <main>
        {/* Hero Section */}
        <Hero
          title="Kami Bukan Sekadar Platform Digital"
          subtitle="Kami adalah platform yang dapat memenuhi segala kebutuhan finansial Anda."
          align="left"
          imageHero={aboutHero}
        />

        {/* Cerita Tomi Indonesia */}
        <div className="section-shell relative overflow-hidden bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
              <div
                ref={phoneRef}
                className={`relative mx-auto w-full max-w-[340px] justify-self-center transition-all duration-700 ease-out sm:max-w-[430px] lg:max-w-[520px] lg:justify-self-start lg:ml-0 xl:ml-4 ${
                  phoneInView
                    ? "opacity-100 translate-y-0 scale-100"
                    : "opacity-50 translate-y-16 scale-90"
                }`}
              >
                <img
                  src={Phone}
                  alt="Phone"
                  className="w-full h-auto object-contain"
                />
              </div>

              <div>
                <h2 className="section-title mb-6">
                  Cerita Tomi Indonesia
                </h2>
                <div className="space-y-5">
                  <p className="section-copy">
                    Di tengah era digital yang berkembang pesat, konsumen semakin
                    terbiasa dengan akses cepat dan mudah ke berbagai layanan dan
                    produk. TOMI adalah solusi digital yang menyederhanakan akses ke
                    berbagai layanan dan produk. Sebagai platform agregator, TOMI
                    mempermudah konsumen dengan menyediakan satu tempat untuk
                    kebutuhan seperti pinjaman tagihan listrik, pendidikan, pulsa,
                    dan berbagai layanan lainnya.
                  </p>
                  <p className="section-copy">
                    TOMI memberikan jangkauan digital dengan cajat menemukan layanan
                    yang dibutuhkan, menjadikan pengalaman lebih efisien dan
                    inklusif, serta siap memenuhi kebutuhan masa depan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-shell section-band">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            {/* Visi & Misi dengan Animasi */}
            <div
              ref={vmRef}
              className={`grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 transition-all duration-700 ease-out ${
                vmInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-16"
              }`}
            >
              {/* Visi Kami */}
              <div className="modern-card flex items-start gap-5 p-7">
                <div className="flex-shrink-0">
                  <img
                    src={visi}
                    alt="Visi Kami"
                    className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    Visi Kami
                  </h3>
                  <p className="section-copy">
                    Menjadi platform agregator terdepan di Indonesia yang
                    memudahkan konsumen menemukan layanan keuangan sesuai
                    kebutuhan, kualitas, dan kepercayaan.
                  </p>
                </div>
              </div>

              {/* Misi Kami */}
              <div className="modern-card flex items-start gap-5 p-7">
                <div className="flex-shrink-0">
                  <img
                    src={misi}
                    alt="Misi Kami"
                    className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    Misi Kami
                  </h3>
                  <ol className="section-copy list-decimal pl-5 space-y-1">
                    <li>
                      Mendorong inovasi teknologi agar layanan lebih cepat.
                    </li>
                    <li>Menyediakan berbagai solusi finansial.</li>
                    <li>Meningkatkan kenyamanan pengguna.</li>
                    <li>Membantu masyarakat menjadi lebih melek finansial.</li>
                    <li>
                      Berkontribusi pada dampak sosial dan ekonomi positif.
                    </li>
                  </ol>
                </div>
              </div>
            </div>

            {/* Nilai Kami: CONNECT dengan Animasi */}
            <div
              ref={valuesRef}
              className={`mb-12 transition-all duration-700 ease-out ${
                valuesInView
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-16"
              }`}
            >
              <div className="text-center mb-8">
                <h2 className="section-title">
                  Nilai Kami: CONNECT
                </h2>
              </div>

              {/* Baris Pertama: 4 Kotak */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                {values.slice(0, 4).map((value, index) => (
                  <div
                    key={index}
                    className="modern-card group flex flex-col items-center p-6 text-center"
                  >
                    <div className="mb-4">
                      <img
                        src={value.image}
                        alt={value.title}
                        className="w-16 h-16 sm:w-20 sm:h-20 object-contain group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <h3 className="text-lg font-bold text-slate-900 mb-2">
                      {value.title}
                    </h3>
                    <p className="text-xs leading-6 text-slate-600">{value.subtitle}</p>
                  </div>
                ))}
              </div>

              {/* Baris Kedua: 3 Kotak - Ditempatkan di Tengah */}
              <div className="flex justify-center">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-4xl">
                  {values.slice(4).map((value, index) => (
                    <div
                      key={index + 4}
                      className="modern-card group flex flex-col items-center p-6 text-center"
                    >
                      <div className="mb-4">
                        <img
                          src={value.image}
                          alt={value.title}
                          className="w-16 h-16 sm:w-20 sm:h-20 object-contain group-hover:scale-110 transition-transform duration-300"
                        />
                      </div>
                      <h3 className="text-lg font-bold text-slate-900 mb-2">
                        {value.title}
                      </h3>
                      <p className="text-xs leading-6 text-slate-600">{value.subtitle}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
